export const twoMinutesFromNow = () => {
  return new Date(new Date().getTime() + 2 * 60 * 1000)
}
